class BuyerHeader {
  constructor() {
    this.BUYER_LEADING_BID_TITLE = [
      {
        title: 'RANKING NO.',
        className: 'summary-ranking-no',
        id: 'ranking_no',
      },
      {
        title: 'SUPPLIER NAME',
        className: 'summary-supplier-name',
        id: 'supplier_name',
      },
      {
        title: 'TOTAL BIDDING AMOUNT',
        className: 'summary-bidding-amount',
        id: 'supplier_name',
      },
      {
        title: 'BIDDING TIME',
        className: 'summary-bidding-time',
        id: 'bidding_time',
      },
      {
        title: 'NO. OF BIDS',
        className: 'summary-no-of-bids',
        id: 'no_of_bids',
      },
      {
        title: 'STATUS',
        className: 'summary-status',
        id: 'status',
      },
      {
        title: 'VIEW BID',
        className: 'summary-view-more center',
        id: 'view_more',
      },
    ]

    this.BUYER_BIDDING_HISTORY_TITLE = [
      {
        title: 'BIDDING NO.',
        className: 'history-bidding-no',
        id: 'bidding_no',
      },
      {
        title: 'SUPPLIER NAME',
        className: 'history-supplier-name',
        id: 'supplier_name',
      },
      {
        title: 'TOTAL BIDDING AMOUNT',
        className: 'history-bidding-amount',
        id: 'bidding_amount',
      },
      {
        title: 'BIDDING TIME',
        className: 'history-bidding-time center',
        id: 'bidding_time',
      },
    ]
  }
}

export default new BuyerHeader()
